import React from "react";
import "./Title.css";

export default function Title() {
  return (
    <div>
      <h3 className="title-name">Laure Smith</h3>
      <h5 className="title-profession">Frontend Developer</h5>
      <p className="title-email">laurasmith.website</p>
    </div>
  );
}
